module.exports = __webpack_public_path__ + "static/media/companylogo.2fb6950e.svg";